export default __webpack_public_path__ + "static/media/crash.60337034.wav";